export const VocabOnboardingSuccess = {
    // Pure Patient
    "welcome_patient_title": ["¡Bienvenido!", "Welcome!"],
    "welcome_patient_msg": ["Tu perfil está listo nos alegra tenerte, en MedCleir nos esforzamos por facilitarte un futuro mas saludable estamos seguros de que juntos podemos lograrlo.", 
        "Your profile is ready, we are happy to have you. At MedCleir we strive to provide you with a healthier future, and we are confident that together we can achieve it."],
    
    // Pure Professional
    "welcome_pro_title": ["Bienvenido, Doctor", "Welcome, Doctor"],
    "welcome_pro_msg": ["Bienvenido a MedCleir, nos esforzamos para proporcionarle herramientas practicas y utiles que faciliten su practica, y juntos proveer a sus pacientes una mejor calidad de vida.", 
        "Welcome to MedCleir. We strive to provide practical and useful tools that facilitate your practice, and together we aim to provide your patients with a better quality of life."],
    
    // Pro to Patient
    "upgrade_patient_title": ["Perfil Actualizado", "Profile Updated"],
    "upgrade_patient_msg": ["Tu historial médico ahora está activo.", "Your medical history is now active."],

    // Patient to Pro
    "upgrade_pro_title": ["Cuenta Actualizada", "Account Upgraded"],
    "upgrade_pro_msg": ["Herramientas profesionales desbloqueadas.", "Professional tools are now unlocked."],
    
    // Actions / Buttons
    "go_to_dashboard": ["Ir al Tablero", "Go to Dashboard"],
    "view_my_health": ["Ver mi Salud", "View my Health"],
    "setup_agenda": ["Configurar Agenda", "Set up Agenda"],
    "start_practicing": ["Empezar Consulta", "Start Practicing"],

    // Features
    "feat_history": ["Historial Médico Digital", "Digital Medical History"],
    "feat_prescriptions": ["Recetas Electrónicas", "E-Prescriptions"],
    "feat_patient_mgmt": ["Gestión Completa de Pacientes", "Complete Patient Management"],
    "feat_self_history": ["Tu propio Perfil Clínico", "Your own Clinical Profile"],
    "feat_dual_role": ["Cambio de Rol Fluido", "Seamless Role Switching"],
    "feat_appointments": ["Agenda de citas sencilla", "Easy Appointment Scheduling"],
    "feat_digital_files": ["Expedientes Digitales Seguros", "Secure Digital Files"],
    "feat_agenda": ["Agenda Médica Inteligente", "Smart Medical Agenda"],
    "feat_clinical_view": ["Vista de Resumen Clínico", "Clinical Summary View"],
    "feat_pro_tools": ["Herramientas de Diagnóstico", "Advanced Diagnostic Tools"],
    "feat_verification": ["Verificación de Identidad", "Identity Verification"],
    "feat_network": ["Red Profesional", "Professional Network"],
    
    // UI strings
    "redirect_notice": ["Redirigiendo en", "Redirecting in"],
    "seconds": ["segundos", "seconds"],
    "social_legend": ["Únete a nuestra comunidad para tips y noticias", "Join our community for tips and updates"],

    "pro_pending_title": ["Verificación en Proceso", "Verification in Progress"],
    "status_under_review": ["Tus credenciales están siendo revisadas por nuestro equipo médico.", "Your credentials are being reviewed by our medical team."],
    "estimated_wait": ["Tiempo estimado de respuesta:", "Estimated response time:"],
    "feat_license_check": ["Validación de Cédula Profesional", "Professional License Validation"],
    "feat_identity_verify": ["Verificación de Identidad", "Identity Verification"],
    "feat_background_check": ["Revisión de Antecedentes", "Background Check"],
    "go_to_landing": ["Volver al Inicio", "Back to Home"],
    "stay_as_patient": ["Continuar como Paciente", "Continue as Patient"],
};